module.exports = __webpack_public_path__ + "img/no_image_available.32f82378.jpg";